<mat-card>
  <app-card-header
    icono="settings_input_antenna"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  @if (!loading) {
    @if (form) {
      <mat-card-content class="card-content-crear">
        <!-- Toggle para modo masivo (solo en creación) -->
        @if (!isEditing) {
          <section class="inputs-group">
            <div>
              <mat-slide-toggle
                [checked]="modoMasivo"
                (change)="toggleModoMasivo()"
                color="primary"
              >
                Carga masiva
              </mat-slide-toggle>
              <small class="ayuda">
                @if (modoMasivo) {
                  Cargá múltiples gateways desde CSV
                } @else {
                  Crear un gateway individual
                }
              </small>
            </div>
          </section>
        }

        <!-- MODO INDIVIDUAL -->
        @if (!modoMasivo && form) {
          <form [formGroup]="form" autocomplete="off">
            <section class="inputs-group">
              <mat-form-field style="width: 100%">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="nombre" />
              </mat-form-field>
              @if (mostrarCamposCliente) {
                <div style="width: 100%">
                  <app-cliente-selector
                    formControlName="idCliente"
                    [showCrearBtn]="
                      helper.tienePermiso('Administración - Crear clientes')
                    "
                  ></app-cliente-selector>
                </div>
              }
            </section>
            <section class="inputs-group">
              @if (!isEditing) {
                <div style="width: 100%">
                  <!-- ng-select emite el ítem entero: se pasa su gatewayId -->
                  <ng-select
                    [items]="gatewaysChirpstack"
                    bindValue="gatewayId"
                    bindLabel="name"
                    formControlName="gatewayEui"
                    placeholder="Gateway"
                    [clearable]="false"
                    appendTo="body"
                    notFoundText="Sin resultados"
                    style="width: 100%"
                    (change)="onGatewaySeleccionado($event?.gatewayId)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.name || item.gatewayId }} ({{ item.gatewayId }})
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.name || item.gatewayId }} ({{ item.gatewayId }})
                    </ng-template>
                  </ng-select>
                  <small class="ayuda">
                    Seleccioná un gateway desde Chirpstack
                  </small>
                </div>
              } @else {
                <mat-form-field style="width: 100%">
                  <mat-label>Gateway EUI</mat-label>
                  <input
                    matInput
                    formControlName="gatewayEui"
                    [readonly]="true"
                  />
                </mat-form-field>
              }
            </section>
            @if (isEditing) {
              <app-content-card title="Ubicación en el mapa" icon="place">
                <section class="inputs-group">
                  <button
                    irxBoton="secundario"
                    type="button"
                    [disabled]="!tieneUbicacionGatewaySeleccionado"
                    (click)="usarUbicacionGatewaySeleccionado()"
                  >
                    <mat-icon>my_location</mat-icon>
                    Usar ubicación de Chirpstack
                  </button>
                </section>
                <div class="map-container-2">
                  <app-mapa-facil
                    (inicializado)="iniciarMapa()"
                    [setMarker]="true"
                    [inputDireccion]="true"
                  ></app-mapa-facil>
                </div>
              </app-content-card>
            }
          </form>
        }

        <!-- MODO MASIVO -->
        @if (modoMasivo && formMasivo) {
          <form [formGroup]="formMasivo" autocomplete="off">
            @if (mostrarCamposCliente) {
              <section class="inputs-group">
                <div style="width: 100%">
                  <app-cliente-selector
                    formControlName="idCliente"
                    [showCrearBtn]="
                      helper.tienePermiso('Administración - Crear clientes')
                    "
                  ></app-cliente-selector>
                </div>
              </section>
            }

            <!-- Área de texto para CSV -->
            <section class="inputs-group" style="flex-direction: column">
              <app-info-banner
                icon="info"
                title="Formato de carga CSV"
                message="Formato: <code style='padding: 2px 6px; border-radius: 3px'>Nombre, GatewayEUI</code><br/><strong>Requisitos:</strong><br/>• Un gateway por línea<br/>• Nombre: nombre del gateway (obligatorio)<br/>• GatewayEUI: 16 caracteres hexadecimales - debe existir en Chirpstack (obligatorio)<br/><strong>Nota:</strong> Los demás datos se completarán automáticamente desde Chirpstack"
                margin="0"
              ></app-info-banner>
              <mat-form-field style="width: 100%">
                <mat-label>Gateways (uno por línea)</mat-label>
                <textarea
                  matInput
                  class="csv"
                  [(ngModel)]="csvData"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Gateway 1, A1B2C3D4E5F60718&#10;Gateway 2, 19283746AB56CDEF&#10;Gateway 3, 0123456789ABCDEF"
                ></textarea>
              </mat-form-field>

              <!-- Errores de validación -->
              @if (validationErrors.length > 0) {
                <div class="errores-csv">
                  <div class="errores-titulo">
                    <mat-icon>error_outline</mat-icon>
                    <strong>Errores de validación</strong>
                  </div>
                  @for (error of validationErrors; track error.line) {
                    <p>
                      <strong>Línea {{ error.line }}:</strong>
                      {{ error.error }}
                    </p>
                  }
                </div>
              }
            </section>
          </form>
        }
      </mat-card-content>

      <!-- Acciones -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="button"
          [disabled]="
            loading || modoMasivo
              ? !formMasivo?.valid || !csvData.trim() || processingMasivo
              : !form?.valid
          "
          (click)="onSubmit()"
        >
          <mat-icon>check</mat-icon>
          {{
            processingMasivo
              ? 'Procesando...'
              : isEditing
                ? 'Guardar'
                : modoMasivo
                  ? 'Crear gateways'
                  : 'Crear'
          }}
        </button>
      </mat-card-actions>
    }
  } @else {
    <mat-card-content class="card-content-crear">
      <section class="inputs-group">
        <app-loading
          text="Cargando formulario..."
          [diameter]="60"
        ></app-loading>
      </section>
    </mat-card-content>
  }
</mat-card>
